var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('rkm-form',{attrs:{"show-legend":""}},[_c('Paciente',{ref:"Paciente",attrs:{"data":{ additionals: _vm.additionals, form: _vm.form, model: _vm.model }}}),_c('Tabs',{ref:"Tabs",attrs:{"data":{ additionals: _vm.additionals, form: _vm.form, model: _vm.model }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }